import getConfig from 'next/config'
import { coreResource } from '@jarvis.oddle/core/env'
import { origin, API_ROOT, IG_API_ROOT, CUST_API_ROOT } from './universal'

// NOTE: Due to a bug in next.js (https://github.com/zeit/next.js/issues/7713), we need to add fallback here to prevent build error
// TODO: Remove fallback when the bug is fixed.
const { publicRuntimeConfig = {} } = getConfig() || {}

/*
  NOTE:
  Testing GA_TRACKING_ID are under jarvis@oddle.me > FESC account
  Live GA_TRACKING_ID is under jarvis@oddle.me > Oddle Main account
  Testing GTM_CONTAINER_ID are under jarvis@oddle.me > FESC account
  Live GTM_CONTAINER_ID is under jarvis@oddle.me > Oddle Main account
  There is no testing account for ADWORDS_CONVERSION_ID
  Live ADWORDS_CONVERSION_ID is under marketing2@oddle.me account
  Testing FACEBOOK_PIXEL_ID are under jarvis@oddle.me > FESC account
  Live FACEBOOK_PIXEL_ID is under jarvis@oddle.me > Oddle account
  All ADDTHIS_PUBLIC_ID are under jarvis@oddle.me
*/
export const {
  CUSTOMISATION_BASE_URL,
  ADDTHIS_PUBLIC_ID,
  ADDTHIS_CONTAINER_CLASS_NAME,
  GA_TRACKING_ID,
  GTM_CONTAINER_ID,
  FACEBOOK_PIXEL_ID,
  SG_ODDLE_EATS_PIXEL_ID,
  SG_ODDLE_EATS_GA_TRACKING_ID,
  SG_ODDLE_EATS_AW_TRACKING_ID,
  ADWORDS_CONVERSION_ID,
  ROLLBAR_ACCESS_TOKEN_CLIENT,
  ENABLE_OPTIMISED_CART,
  ODDLE_PASS_CLIENT_ID,
  ODDLE_PASS_REDIRECT_URL,
  ODDLE_PASS_JS_URL,
  SEGMENT_API_KEY,
  ODDLE_EATS_URL,
  IMAGEKIT_ID,
  PREFERENCES_ODDLE_DOMAIN,
  NR_BROWSER_APP_ID
} = publicRuntimeConfig

export const DEFAULT_PRODUCT_IMAGE_URL = coreResource(
  '/images/default-product.png'
)
export const DEFAULT_BANNER_IMAGE_URL = coreResource(
  '/images/default-banner.png'
)

export const ODDLE_BACK_LINK =
  'https://oddle.me/?utm_source=Shopping%20Cart&utm_medium=Click&utm_campaign=Shopping%20Cart%20Link'

// Enable this to inject readable id for better product url for shopping cart
export const USE_PRODUCT_READABLE_ID = true
export const READABLE_ID_FIELD = 'readableId'
export const ID_OFFSET = 4
export const READABLE_ID_MAX_LENGTH = 1500 // NOTE: Max URL length is 2048: https://stackoverflow.com/questions/417142/what-is-the-maximum-length-of-a-url-in-different-browsers

export { API_ROOT, IG_API_ROOT, CUST_API_ROOT, origin }
